import { api } from "../../services/Api.js";

export function get_calendar({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // return chanable promise
    return api
    .post(school,"get_calendar.php",payload)
    .then( result =>{ 
            
      commit('SET_CALENDAR', {key:payload.store_key,calendar:result.data});
      
    })
    .catch( () => {
      //console.log("ERROR GETTING CALENDAR",error);
    })

}